import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  INotificationPreferences,
  INotificationPreferencesResponse,
} from 'src/app/core/models/notification-preferences';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfileRepositoryService {
  constructor(private http: HttpClient) {}

  /**
   * Get Notification Preferences
   */
  getNotificationPreferences(): Observable<INotificationPreferencesResponse> {
    return this.http.get<any>(`${environment.restUrl}/v1/company/contact/escalation-preferences`);
  }

  /**
   * Update Notification Preferences
   */
  updateNotificationPreferences(data: INotificationPreferences): Observable<INotificationPreferences> {
    return this.http.put<any>(`${environment.restUrl}/v1/company/contact/escalation-preferences`, data);
  }
}
